import { logErrorToConsole } from '../constants';

const getCurrentPageURL = () => {
  try {
    return (window && window.location && window.location.href) || undefined;
  } catch (error) {
    logErrorToConsole('[ERROR] occured in getCurrentPageURL: ', error);
    return undefined;
  }
};

export default getCurrentPageURL;
